// @ts-nocheck
import {
    chain,
    PopulateApiParameter,
    SendDataToApi,
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";
import { getFieldValue } from "@store/Extensions/Store/Components/ContactUsForm/ContactFormSelectors";
import { submitContactUsForm } from "@store/Framework/Services/EmailService";
import { addToChainAfter, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, PopulateApiParameter, props => {
    const state = props.getState();

    ["companyName", "postalCode", "subscribeState"].forEach(x => {
        (props.apiParameter as any)[x] = getFieldValue(state, x) || false;
    });
});

replaceInChain(chain, SendDataToApi, async props => {
    await submitContactUsForm(props.apiParameter);
});
